'use client'
import { Sora } from 'next/font/google'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const sora = Sora({ subsets: ['latin'] })

type Props = {
  activeUrl?: string
  active?: boolean
  hiddenLinks?: Array<'home' | 'about-us' | 'prescribers' | 'clinics' | 'contact' | 'address'>
  showClinicPatientLinks?: boolean
}

const NavBarLinks = (props: Props) => {
  const pathname = usePathname()
  let activeUrl
  const isHidden = (link: NonNullable<Props['hiddenLinks']>[number]) => props.hiddenLinks?.includes(link)

  switch (pathname) {
    case '/':
      activeUrl = 'home'
      break
    case '/about-us':
      activeUrl = 'about-us'
      break
    case '/clinic/cliniclisting':
      activeUrl = 'clinics'
      break
    case '/clinic/dash/live':
      activeUrl = 'consultation'
      break
    case '/clinic/prescriptions':
      activeUrl = 'prescription'
      break
    case '/clinic/orders':
      activeUrl = 'orders'
      break
    case '/clinic/myaddress':
      activeUrl = 'address'
      break
    case '/clinic/prescriberslisting':
      activeUrl = 'prescribers'
      break
    case '/contact':
      activeUrl = 'contact'
      break
    default:
      activeUrl = ''
  }

  return (
    <div
      className={`
        flex flex-col justify-items-center md:gap-10 gap-7 pl-2 text-slate-400

        md:flex-col

        ${sora.className}
      `}
    >
      <Link
        href={'/'}
        className={`
          ${
            (props.active && props.activeUrl === 'home') || activeUrl === 'home'
              ? `font-medium text-[#F59405]`
              : `text-black`
          }

          hover:text-[#F59405]
        `}
      >
        Home
      </Link>
      {!isHidden('about-us') && (
        <Link
          href={'/about-us'}
          className={`
            ${
              (props.active && props.activeUrl === 'about-us') || activeUrl === 'about-us'
                ? `font-medium text-[#F59405]`
                : `text-black`
            }

            hover:text-[#F59405]
          `}
        >
          About us
        </Link>
      )}
      <Link
        href={'/clinic/prescriberslisting'}
        className={`
          ${
           (props.active && props.activeUrl === 'prescribers') || activeUrl === 'prescribers'
             ? `font-medium text-[#F59405]`
             : `text-black`
         }

          hover:text-[#F59405]
        `}
      >
        Prescribers
      </Link>
      <Link
        href={'/clinic/cliniclisting'}
        className={`
          ${
            (props.active && props.activeUrl === 'clinics') || activeUrl === 'clinics'
              ? `font-medium text-[#F59405]`
              : `text-black`
          }

          hover:text-[#F59405]
        `}
      >
        Clinics
      </Link>
      {props.showClinicPatientLinks && (
        <>
          <Link
            href={'/clinic/dash/live'}
            className={`
              ${
                (props.active && props.activeUrl === 'consultation') || activeUrl === 'consultation'
                  ? `font-medium text-[#F59405]`
                  : `text-black`
              }

              hover:text-[#F59405]
            `}
          >
            Consultation
          </Link>
          <Link
            href={'/clinic/prescriptions'}
            className={`
              ${
                (props.active && props.activeUrl === 'prescription') || activeUrl === 'prescription'
                  ? `font-medium text-[#F59405]`
                  : `text-black`
              }

              hover:text-[#F59405]
            `}
          >
            Prescription
          </Link>
          <Link
            href={'/clinic/orders'}
            className={`
              ${
                (props.active && props.activeUrl === 'orders') || activeUrl === 'orders'
                  ? `font-medium text-[#F59405]`
                  : `text-black`
              }

              hover:text-[#F59405]
            `}
          >
            Orders
          </Link>
          {!isHidden('address') && (
            <Link
              href={'/clinic/myaddress'}
              className={`
                ${
                  (props.active && props.activeUrl === 'address') || activeUrl === 'address'
                    ? `font-medium text-[#F59405]`
                    : `text-black`
                }

                hover:text-[#F59405]
              `}
            >
              Address
            </Link>
          )}
        </>
      )}
      {!isHidden('contact') && (
        <Link
          href={'/contact'}
          className={`
            ${
              (props.active && props.activeUrl === 'contact') || activeUrl === 'contact'
                ? `font-medium text-[#F59405]`
                : `text-black`
            }

            hover:text-[#F59405]
          `}
        >
          Contact us
        </Link>
      )}
    </div>
  )
}

export default NavBarLinks
